"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { cardAnatomy } from "@chakra-ui/react/anatomy"

const card = defineSlotRecipe({
  className: "chakra-card",
  slots: cardAnatomy.keys(),
  variants: {
    variant: {
      filled: {
        root: { bg: "card" },
      },
      kpi: {
        root: {
          background: "card",
          border: "none",
          borderRadius: "{radii.card}",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "{shadows.card}",
        },
        header: {
          padding: "0",
          marginBottom: "6px",
        },
        body: {
          padding: "0",
        },
      },
    },
  },
})

export default card
